import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';
import Styles from 'src/components/Styles';
import {Platform} from 'react-native';
import Localized from 'src/constants/AppStrings';
import {
  checkoutStylesTemplate1,
  checkoutStylesTemplate2,
} from '../CheckoutStyles';
import {getHeaderDescriber} from 'src/components/elements/headerDescriptor/DescriptorType';

const scanandPayThemeConfigurations = {
  [BuildTypes.default]: {
    primaryColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    deleteIconColor: Styles.Colors.PayNew.primary01,
    discountTagColor: Styles.Colors.PayNew.success,
    emptyCartImage: require('../../../img/scan-product.png'),
    categorySelected: {
      selectedCategoryColor: Styles.Colors.PayNew.primary01,
      selectCategoryBorderColor: Styles.Colors.PayNew.primary01,
    },
    productListingRoundedBorder: Styles.Spacing.m2,
    searchIconColor: Styles.Colors.PayNew.darkHuesBase04,
    textColor: Styles.Colors.PayNew.black01,
    priceDecoration: 'line-through' as const,
    discountTagDimensions: {
      width: 19,
      height: 23,
    },
    promoFontSize: Styles.Fonts.f7,
    toggleStylesAndCurrencies: true,
    cartPromoTextMargin: {
      marginRight: 5,
      marginTop: 0,
    },
    supMargin: {
      marginLeft: Styles.Spacing.m4 + Styles.Spacing.m3,
    },
    changePickTime: Localized.Labels.change,
    btnTextColor: Styles.Colors.PayNew.primary01,
    checkoutStyles: checkoutStylesTemplate1,
    subHeaderFontSize: getHeaderDescriber().subHeaderFontSize(),
    showDashedLinebeforeItems: true,
    prepMethodBtnColor: 'rgba(0, 109, 255, 0.15)',
    prepMethodSelectedText: Styles.Colors.PayNew.black01,
    showYourOrderLabel: false,
    deleteIconDimension: Styles.Heights.touchTargetHeight1,
    selectedProductsFont: Styles.Fonts.f7,
    cartItemPrice: Styles.Fonts.sectionHeader,
    showPlus: true,
    modifierTextsColor: Styles.Colors.PayNew.darkHuesBase04,
    bundleItemsBackgroundColor: Styles.Colors.PayNew.blueHuesBase05,
    deleteIconFillColor: Styles.Colors.PayNew.darkHuesBase04,
    payBtnColor: Styles.Colors.PayNew.white01,
    rewardsPayColor: Styles.Colors.PayLegacy.grayScaleBase03,
    showDividerScanPay: false,
    categoriesSelectedColor: Styles.Colors.PayNew.white01,
    enableDiscountDisplay: false,
    totalLabel: Localized.Labels.total,
    totalFontSize: Styles.Fonts.f10,
    rewardDiscountTextColor: Styles.Colors.PayNew.black01,
    rewardDiscountLabelColor: Styles.Colors.PayNew.success,
    emptyCartColors: {
      primaryFill: Styles.Colors.PayNew.primary01,
      secondaryFill: Styles.Colors.PayNew.support01,
    },
    searchFieldElevation: 0,
    showCategoriesShadow: false,
    snackBorderColor: Styles.Colors.PayNew.primary01,
    okayBtnTextColor: Styles.white,
    snackRoundedBtnTextColor: Styles.Colors.PayNew.primary01,
  },
  [BuildTypes.canteen]: {
    primaryColor: Styles.Colors.Canteen.darkGreen,
    textFontFamily: Styles.FontFamily.robotoRegular,
    deleteIconColor: Styles.primaryColor,
    discountTagColor: Styles.Colors.Canteen.green,
    emptyCartImage: require('../../../img/scan-product-canteen.png'),
    categorySelected: {
      selectedCategoryColor: Styles.Colors.Canteen.darkGreen,
      selectCategoryBorderColor: '',
    },
    productListingRoundedBorder: 0,
    searchIconColor: '',
    textColor: Styles.Colors.PayNew.black01,
    priceDecoration: 'line-through' as const,
    discountTagDimensions: {
      width: 15,
      height: 18,
    },
    supMargin: {
      marginLeft: Styles.Spacing.m4 - Styles.Spacing.m2,
    },
    promoFontSize: Styles.Fonts.f8,
    toggleStylesAndCurrencies: true,
    cartPromoTextMargin: {
      marginRight: 5,
      marginTop: Platform.OS === 'android' ? 0 : 1,
    },
    changePickTime: Localized.Labels.edit_info,
    btnTextColor: Styles.Colors.Canteen.darkGreen,
    checkoutStyles: checkoutStylesTemplate2,
    subHeaderFontSize: Styles.Fonts.f7,
    showDashedLinebeforeItems: false,
    prepMethodBtnColor: 'rgba(64, 159, 104, 0.15)',
    prepMethodSelectedText: Styles.Colors.Canteen.darkGreen,
    showYourOrderLabel: true,
    deleteIconDimension: Styles.Spacing.m4,
    selectedProductsFont: Styles.Fonts.f1,
    cartItemPrice: Styles.Fonts.f1,
    showPlus: false,
    modifierTextsColor: Styles.Colors.PayNew.black01,
    bundleItemsBackgroundColor: 'rgba(64, 159, 104, 0.15)',
    deleteIconFillColor: Styles.Colors.PayNew.darkHuesBase03,
    payBtnColor: Styles.Colors.PayNew.white01,
    rewardsPayColor: Styles.Colors.PayNew.darkHuesBase03,
    showDividerScanPay: true,
    categoriesSelectedColor: Styles.Colors.PayNew.white01,
    enableDiscountDisplay: false,
    totalLabel: Localized.Buttons.your_total,
    totalFontSize: Styles.Fonts.sectionHeader,
    rewardDiscountTextColor: Styles.Colors.Canteen.green,
    rewardDiscountLabelColor: Styles.Colors.Canteen.green,
    emptyCartColors: {
      primaryFill: Styles.Colors.Canteen.darkGreen,
      secondaryFill: Styles.Colors.Canteen.lightGreen,
    },
    searchFieldElevation: 0,
    showCategoriesShadow: false,
    snackBorderColor: Styles.Colors.Canteen.darkGreen,
    okayBtnTextColor: Styles.white,
    snackRoundedBtnTextColor: Styles.Colors.Canteen.darkGreen,
  },
  [BuildTypes.companykitchen]: {
    primaryColor: Styles.Colors.CompanyKitchen.green,
    textFontFamily: Styles.FontFamily.latoRegular,
    deleteIconColor: Styles.primaryColor,
    discountTagColor: Styles.Colors.PayNew.success,
    emptyCartImage: require('../../../img/ScanProductCK.png'),
    categorySelected: {
      selectedCategoryColor: Styles.Colors.CompanyKitchen.green,
      selectCategoryBorderColor: Styles.Colors.CompanyKitchen.green,
    },
    productListingRoundedBorder: 0,
    searchIconColor: '',
    textColor: Styles.Colors.PayNew.black01,
    priceDecoration: 'line-through' as const,
    discountTagDimensions: {
      width: 15,
      height: 18,
    },
    supMargin: {
      marginLeft: Styles.Spacing.m4 - Styles.Spacing.m2,
    },
    promoFontSize: Styles.Fonts.f8,
    toggleStylesAndCurrencies: true,
    cartPromoTextMargin: {
      marginRight: 5,
      marginTop: Platform.OS === 'android' ? 0 : 1,
    },
    changePickTime: Localized.Labels.edit_info,
    btnTextColor: Styles.Colors.PayNew.black01,
    checkoutStyles: checkoutStylesTemplate2,
    subHeaderFontSize: Styles.Fonts.f7,
    showDashedLinebeforeItems: false,
    prepMethodBtnColor: 'rgba(132, 189, 0, 0.16)',
    prepMethodSelectedText: Styles.Colors.PayNew.black01,
    showYourOrderLabel: true,
    deleteIconDimension: Styles.Spacing.m4,
    selectedProductsFont: Styles.Fonts.f1,
    cartItemPrice: Styles.Fonts.f1,
    showPlus: false,
    modifierTextsColor: Styles.Colors.PayNew.black01,
    bundleItemsBackgroundColor: 'rgba(132, 189, 0, 0.16)',
    deleteIconFillColor: Styles.Colors.PayNew.darkHuesBase03,
    payBtnColor: Styles.Colors.PayNew.black01,
    rewardsPayColor: Styles.Colors.PayNew.darkHuesBase03,
    showDividerScanPay: true,
    categoriesSelectedColor: Styles.Colors.PayNew.black01,
    enableDiscountDisplay: false,
    totalLabel: Localized.Buttons.your_total,
    totalFontSize: Styles.Fonts.sectionHeader,
    rewardDiscountTextColor: Styles.Colors.Canteen.green,
    rewardDiscountLabelColor: Styles.Colors.Canteen.green,
    emptyCartColors: {
      primaryFill: Styles.Colors.Canteen.darkGreen,
      secondaryFill: Styles.Colors.Canteen.lightGreen,
    },
    searchFieldElevation: 0,
    showCategoriesShadow: false,
    snackBorderColor: Styles.Colors.CompanyKitchen.green,
    okayBtnTextColor: Styles.Colors.PayNew.black01,
    snackRoundedBtnTextColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypes.refive]: {
    primaryColor: Styles.Colors.Refive.activeFooterBlue,
    textFontFamily: Styles.FontFamily.figtreeRegular,
    deleteIconColor: Styles.Colors.PayNew.darkHuesBase04,
    discountTagColor: Styles.Colors.Refive.activeFooterBlue,
    emptyCartImage: require('../../../img/scanProductRefive.png'),
    categorySelected: {
      selectedCategoryColor: Styles.Colors.Refive.activeFooterBlue,
      selectCategoryBorderColor: Styles.Colors.Refive.activeFooterBlue,
    },
    productListingRoundedBorder: Styles.Spacing.m2,
    searchIconColor: Styles.Colors.PayLegacy.grayScaleBase04,
    textColor: Styles.Colors.PayNew.black01,
    priceDecoration: 'line-through' as const,
    discountTagDimensions: {
      width: 19,
      height: 23,
    },
    supMargin: {
      marginLeft: Styles.Spacing.m4 + Styles.Spacing.m3,
    },
    promoFontSize: Styles.Fonts.f7,
    toggleStylesAndCurrencies: true,
    cartPromoTextMargin: {
      marginRight: 5,
      marginTop: 0,
    },
    changePickTime: Localized.Labels.change,
    btnTextColor: Styles.Colors.Refive.activeFooterBlue,
    checkoutStyles: checkoutStylesTemplate1,
    subHeaderFontSize: getHeaderDescriber().subHeaderFontSize(),
    showDashedLinebeforeItems: true,
    prepMethodBtnColor: 'rgba(69, 136, 253, 0.15)',
    prepMethodSelectedText: Styles.Colors.Refive.navy,
    showYourOrderLabel: false,
    deleteIconDimension: Styles.Heights.touchTargetHeight1,
    selectedProductsFont: Styles.Fonts.f7,
    cartItemPrice: Styles.Fonts.sectionHeader,
    showPlus: true,
    modifierTextsColor: Styles.Colors.PayNew.darkHuesBase04,
    bundleItemsBackgroundColor: Styles.Colors.PayNew.blueHuesBase05,
    deleteIconFillColor: Styles.Colors.PayNew.darkHuesBase04,
    payBtnColor: Styles.Colors.PayNew.white01,
    rewardsPayColor: Styles.Colors.PayLegacy.grayScaleBase03,
    showDividerScanPay: false,
    categoriesSelectedColor: Styles.Colors.PayNew.white01,
    enableDiscountDisplay: false,
    totalLabel: Localized.Labels.total,
    totalFontSize: Styles.Fonts.f10,
    rewardDiscountTextColor: Styles.Colors.PayNew.black01,
    rewardDiscountLabelColor: Styles.Colors.PayNew.success,
    snackBorderColor: Styles.Colors.Refive.activeFooterBlue,
    snackRoundedBtnTextColor: Styles.Colors.Refive.activeFooterBlue,
    okayBtnTextColor: Styles.white,
    emptyCartColors: {
      primaryFill: Styles.Colors.PayNew.primary01,
      secondaryFill: Styles.Colors.PayNew.support01,
    },
    searchFieldElevation: 5,
    showCategoriesShadow: true,
  },
};
export const scanAndPayTemplate =
  scanandPayThemeConfigurations[Settings.buildType];
